// extracted by mini-css-extract-plugin
export var image = "kc_dr";